<template>
  <div style="height: 100dvh" class="position-relative">
    <div class="mobile-header justify-content-start">
      <img
        @click="
          !showMainPage
            ? ((showMainPage = true),
              (showAllSwitch = false),
              (showForm = false),
              (showPassword = false),
              (showAllDevices = false),
              (showallcheckbox = false),
              (changePassword = false),
              (showConcern = false),
              (showQuery = false))
            : $router.go(-1)
        "
        class="ml-3 mr-3"
        src="../../assets/mobProfile/blueBackArrow.svg"
        alt=""
      />
      <span class="mb-header-txt" v-if="showMainPage">Account Settings</span>
      <span class="mb-header-txt" v-if="showForm"> Personal Data</span>
      <span class="mb-header-txt" v-if="showPassword || changePassword"
        >Basic Authentication</span
      >
      <span class="mb-header-txt" v-if="showAllDevices">Device Activity</span>
      <span class="mb-header-txt" v-if="showQuery || showConcern"
        >Raise a query</span
      >
    </div>

    <div v-if="showMainPage" class="mobile-body">
      <div class="mb-white-body">
        <div
          class="d-flex align-items-center justify-content-between"
          @click="personalData()"
        >
          <div class="d-flex align-items-center">
            <div>
              <img
                class="mr-2"
                src="../../assets/mobProfile/personalData.svg"
                alt=""
              />
            </div>
            <div class="mb-black-bold-2">Personal Data</div>
          </div>
          <div>
            <img src="../../assets/mobProfile/mb-rightArrow.svg" alt="" />
          </div>
        </div>
        <div
          class="d-flex align-items-center justify-content-between mt-3"
          @click="basicAuthentication()"
        >
          <div class="d-flex align-items-center">
            <div>
              <img
                class="mr-2"
                src="../../assets/mobProfile/basicauth.svg"
                alt=""
              />
            </div>
            <div class="mb-black-bold-2">Basic Authentication</div>
          </div>
          <div>
            <img src="../../assets/mobProfile/mb-rightArrow.svg" alt="" />
          </div>
        </div>
        <div
          class="d-flex align-items-center justify-content-between mt-3"
          @click="deviceActivity()"
        >
          <div class="d-flex align-items-center">
            <div>
              <img
                class="mr-2"
                src="../../assets/mobProfile/deviceact.svg"
                alt=""
              />
            </div>
            <div class="mb-black-bold-2">Device Activity</div>
          </div>
          <div>
            <img src="../../assets/mobProfile/mb-rightArrow.svg" alt="" />
          </div>
        </div>
        <div
          class="d-flex align-items-center justify-content-between mt-3"
          @click="raiseQuerytab()"
        >
          <div class="d-flex align-items-center">
            <div>
              <img
                class="mr-2"
                src="../../assets/mobProfile/raise-query.svg"
                alt=""
              />
            </div>
            <div class="mb-black-bold-2">Raise a Query</div>
          </div>
          <div>
            <img src="../../assets/mobProfile/mb-rightArrow.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="showDataShimmer">
      <div class="mobile-inner-body p-3">
        <div class="mt-1">
          <b-skeleton class="ml-3 mt-4 w-85 h-25"></b-skeleton>
        </div>
        <div class="mt-5">
          <b-skeleton class="ml-3 mt-4 w-85 h-25"></b-skeleton>
        </div>
        <div class="mt-5">
          <b-skeleton class="ml-3 mt-4 w-85 h-25"></b-skeleton>
        </div>
        <div class="mt-5">
          <b-skeleton class="ml-3 mt-4 w-85 h-25"></b-skeleton>
        </div>
      </div>
    </div>

    <div v-else-if="!showDataShimmer && showForm" class="mobile-body">
      <div class="mobile-inner-body p-3">
        <div class="position-relative">
          <div class="mb-modal-label">
            User Name<span class="asterik">*</span>
          </div>
          <div class="mt-1">
            <b-form-input
              class="mb-profile-inputField"
              type="text"
              v-model="User.username"
              disabled
            ></b-form-input>
          </div>
        </div>
        <div class="position-relative mt-3">
          <div class="mb-modal-label">
            First Name<span class="asterik">*</span>
          </div>
          <div class="mt-1">
            <b-form-input
              :class="
                editProfile && $v.profileDetails.firstName.$error
                  ? 'mb-profile-inputField-error'
                  : ''
              "
              placeholder="Enter First Name"
              class="mb-profile-inputField"
              type="text"
              v-model="profileDetails.firstName"
              :disabled="editProfile == false"
              @keypress="alphabetsOnly"
              spellCheck="false"
            ></b-form-input>
          </div>
          <div
            class="candash-errortxt errortxt-pos"
            v-if="
              editProfile &&
              $v.profileDetails.firstName.$dirty &&
              !$v.profileDetails.firstName.required
            "
          >
            Required
          </div>
          <div
            class="candash-errortxt errortxt-pos"
            v-if="!$v.profileDetails.firstName.maxLength"
          >
            Exceeded the max char length of 38
          </div>
          <div
            v-if="
              editProfile &&
              $v.profileDetails.firstName.$dirty &&
              !$v.profileDetails.firstName.alphaNumeric
            "
            class="candash-errortxt errortxt-pos"
          >
            Invalid Name
          </div>
        </div>
        <div class="mt-3 position-relative">
          <div class="mb-modal-label">
            Last Name<span class="asterik">*</span>
          </div>
          <div class="mt-1">
            <b-form-input
              :class="
                editProfile && $v.profileDetails.lastName.$error
                  ? 'mb-profile-inputField-error'
                  : ''
              "
              placeholder="Enter Last Name"
              class="mb-profile-inputField"
              type="text"
              v-model="profileDetails.lastName"
              :disabled="editProfile == false"
              @keypress="alphabetsOnly"
              spellCheck="false"
            ></b-form-input>
          </div>
          <div
            class="candash-errortxt errortxt-pos"
            v-if="
              editProfile &&
              $v.profileDetails.lastName.$dirty &&
              !$v.profileDetails.lastName.required
            "
          >
            Required
          </div>
          <div
            class="candash-errortxt errortxt-pos"
            v-if="
              $v.profileDetails.lastName.$dirty &&
              !$v.profileDetails.lastName.maxLength
            "
          >
            Exceeded the max char length of 38
          </div>
          <div
            v-if="
              editProfile &&
              $v.profileDetails.lastName.$dirty &&
              !$v.profileDetails.lastName.alphaNumeric
            "
            class="candash-errortxt errortxt-pos"
          >
            Invalid Name
          </div>
        </div>

        <div class="mt-3">
          <div class="mb-modal-label">Email</div>
          <div class="mt-1">
            <b-form-input
              disabled
              placeholder="abc@dfg.com"
              class="mb-profile-inputField"
              v-model="profileDetails.email"
              spellCheck="false"
            ></b-form-input>
          </div>
        </div>
      </div>
      <div class="mobile-footer pr-3">
        <div v-if="editProfile" class="d-flex position-relative">
          <b-button
            class="acs-cancelBtn-modal"
            :disabled="profileLoader == true"
            @click="(editProfile = false), reassignPersonalDetails()"
            >Cancel</b-button
          >
          <b-button
            :class="
              profileLoader
                ? 'acs-addBtn-modal loader-class ml-4 defaultCursor '
                : 'acs-addBtn-modal ml-4 pointer'
            "
            @click="getProfile()"
            ><span v-if="!profileLoader">Save</span></b-button
          >
          <Loader v-if="profileLoader" class="profile-loader" />
        </div>
        <!-- v-else-if="!editProfile " -->
        <div v-else-if="!editProfile">
          <b-button class="acs-addBtn-modal ml-3" @click="editPersonalData()"
            >Edit</b-button
          >
        </div>
      </div>
    </div>
    <div v-if="showPassword" class="mobile-body">
      <div class="mobile-inner-body p-3">
        <div>
          <div class="mb-modal-label">Password</div>
          <div class="mt-1">
            <b-form-input
              disabled
              placeholder="**********"
              class="mb-profile-inputField"
            ></b-form-input>
          </div>
        </div>
      </div>
      <div class="mobile-footer pr-3">
        <b-button
          class="acs-addBtn-modal ml-3"
          @click="
            (changePassword = true),
              (showPassword = false),
              (showCurrentPassword = false),
              (showNewPassword = false),
              (passwordDetails.newPswd = ''),
              (hasUppercase = false),
              (hasLowercase = false),
              (hasSplcharacter = false),
              (hasNumber = false),
              (matchCriteria = false)
          "
          >Reset</b-button
        >
        <!-- <b-button class="acs-addBtn-modal ml-3">Edit</b-button> -->
      </div>
    </div>
    <div v-if="changePassword" class="mobile-body">
      <div class="mobile-inner-body p-3">
        <div class="position-relative">
          <div class="mb-modal-label">
            Current Password<span class="asterik">*</span>
          </div>
          <div class="mt-1 position-relative">
            <b-form-input
              :class="
                $v.passwordDetails.currentPassword.$error ||
                !$v.passwordDetails.currentPassword.maxLength ||
                checkCurrentPsw == true
                  ? 'mb-profile-inputField-error'
                  : ''
              "
              placeholder="Enter Current Password"
              class="mb-profile-inputField"
              :type="showCurrentPassword ? 'text' : 'password'"
              v-model="passwordDetails.currentPassword"
              :autocomplete="showCurrentPassword ? 'off' : 'new-password'"
              @paste.prevent
            ></b-form-input>
            <img
              @click="togglePasswordVisibility('showCurrentPassword')"
              v-if="showCurrentPassword"
              class="cd-hlepsec-searchicon"
              src="../../assets/mobProfile/mb-view-2.svg"
              alt=""
            />
            <img
              v-else
              @click="togglePasswordVisibility('showCurrentPassword')"
              class="cd-hlepsec-searchicon pointer"
              src="../../assets/mobProfile/not-view-icon.svg"
              alt=""
            />
          </div>
          <div
            class="candash-errortxt errortxt-pos ml-1"
            v-if="
              $v.passwordDetails.currentPassword.$dirty &&
              !$v.passwordDetails.currentPassword.required
            "
          >
            Required
          </div>
          <div
            class="candash-errortxt errortxt-pos ml-1"
            v-else-if="!$v.passwordDetails.currentPassword.maxLength"
          >
            Exceeded the max char length of 55
          </div>
          <div
            class="candash-errortxt errortxt-pos ml-1"
            v-if="
              passwordDetails.currentPassword != '' && checkCurrentPsw == true
            "
          >
            Current password is incorrect
          </div>
        </div>
        <div class="mt-3 position-relative">
          <div class="mb-modal-label">
            New Password<span class="asterik">*</span>
          </div>
          <div class="mt-1 position-relative">
            <b-form-input
              :class="{
                'mb-profile-inputField-error':
                  $v.passwordDetails.newPswd.$error ||
                  !$v.passwordDetails.newPswd.maxLength ||
                  (checkNewPsw == false && passwordDetails.newPswd != ''),
                'pr-55':
                  checkNewPsw == true &&
                  passwordDetails.newPswd != '' &&
                  hasUppercase &&
                  hasLowercase &&
                  hasNumber &&
                  hasSplcharacter,
              }"
              placeholder="Enter New Password"
              v-model="passwordDetails.newPswd"
              @input="validatePassword"
              :type="showNewPassword ? 'text' : 'password'"
              :autocomplete="showNewPassword ? 'off' : 'new-password'"
              class="mb-profile-inputField"
              @paste.prevent
            ></b-form-input>
            <img
              v-if="showNewPassword"
              @click="togglePasswordVisibility('showNewPassword')"
              class="cd-hlepsec-searchicon"
              src="../../assets/mobProfile/mb-view-2.svg"
              alt=""
            />
            <img
              v-else
              @click="togglePasswordVisibility('showNewPassword')"
              class="cd-hlepsec-searchicon pointer"
              src="../../assets/mobProfile/not-view-icon.svg"
              alt=""
            />
            <img
              class="mbPro-hlepsec-searchicon"
              v-if="
                checkNewPsw == true &&
                passwordDetails.newPswd != '' &&
                hasUppercase &&
                hasLowercase &&
                hasNumber &&
                hasSplcharacter
              "
              src="../../assets/New Profile/match.svg"
              alt=""
            />

            <img
              v-else-if="passwordDetails.newPswd != '' && checkNewPsw == false"
              class="mbPro-hlepsec-searchicon"
              src="../../assets/New Profile/no-match.svg"
              alt=""
            />
          </div>
          <div
            v-if="passwordDetails.newPswd != '' && checkNewPsw == false"
            class="adjust-uppercase candash-errortxt ml-1"
          >
            New Password cannot be same as current password
          </div>
          <div
            v-else-if="!$v.passwordDetails.newPswd.maxLength"
            class="adjust-uppercase candash-errortxt ml-1"
          >
            Exceeded the max char length of 55
          </div>
          <!-- <div class="candash-errortxt errortxt-pos">Error txt</div> -->
        </div>
        <div class="d-flex flex-wrap align-items-center mt-2">
          <div class="">
            <div v-if="hasUppercase" class="d-flex align-items-center">
              <img src="../../assets/New Profile/select-uppercase.svg" alt="" />
              <div class="mb-green-font ml-1">
                <!-- for reject uppercase font ---- reject-uppercase-font -->
                1 Upper case
              </div>
            </div>
            <div v-else class="d-flex align-items-center">
              <img src="../../assets/New Profile/reject-uppercase.svg" alt="" />
              <div class="mb-red-font ml-1">
                <!-- for reject uppercase font ---- reject-uppercase-font -->
                1 Upper case
              </div>
            </div>
          </div>

          <div class="ml-2">
            <div
              v-if="hasLowercase && passwordDetails.newPswd != ''"
              class="d-flex align-items-center"
            >
              <img src="../../assets/New Profile/select-uppercase.svg" alt="" />
              <div class="mb-green-font ml-1">
                <!-- for reject uppercase font ---- reject-uppercase-font -->
                3 Lower case
              </div>
            </div>
            <div v-else class="d-flex align-items-center">
              <img src="../../assets/New Profile/reject-uppercase.svg" alt="" />
              <div class="mb-red-font ml-1">
                <!-- for reject uppercase font ---- reject-uppercase-font -->
                3 Lower case
              </div>
            </div>
          </div>
          <div class="ml-2">
            <div v-if="hasSplcharacter" class="d-flex align-items-center">
              <img src="../../assets/New Profile/select-uppercase.svg" alt="" />
              <div class="mb-green-font ml-1">
                <!-- for reject uppercase font ---- reject-uppercase-font -->
                1 Special character
              </div>
            </div>
            <div v-else class="d-flex align-items-center">
              <img src="../../assets/New Profile/reject-uppercase.svg" alt="" />
              <div class="mb-red-font ml-1">
                <!-- for reject uppercase font ---- reject-uppercase-font -->
                1 Special character
              </div>
            </div>
          </div>
          <div class="mt-1">
            <div v-if="hasNumber" class="d-flex align-items-center">
              <img src="../../assets/New Profile/select-uppercase.svg" alt="" />
              <div class="mb-green-font ml-1">
                <!-- for reject uppercase font ---- reject-uppercase-font -->
                1 Number
              </div>
            </div>
            <div v-else class="d-flex align-items-center">
              <img src="../../assets/New Profile/reject-uppercase.svg" alt="" />
              <div class="mb-red-font ml-1">
                <!-- for reject uppercase font ---- reject-uppercase-font -->
                1 Number
              </div>
            </div>
          </div>
        </div>
        <div class="mt-3 position-relative">
          <div class="mb-modal-label">
            Confirm Password<span class="asterik">*</span>
          </div>
          <div class="mt-1">
            <b-form-input
              :class="
                $v.passwordDetails.confirmPswd.$error ||
                !$v.passwordDetails.confirmPswd.maxLength ||
                (passwordDetails.confirmPswd != '' &&
                  !passwordsMatch &&
                  passwordDetails.newPswd != '')
                  ? 'mb-profile-inputField-error'
                  : ''
              "
              placeholder="Confirm Password"
              class="mb-profile-inputField"
              v-model="passwordDetails.confirmPswd"
              type="password"
              @paste.prevent
              :autocomplete="showConfirmPassword ? 'off' : 'new-password'"
            ></b-form-input>

            <img
              class="match-hlepsec-searchicon"
              v-if="
                passwordsMatch &&
                passwordDetails.confirmPswd != '' &&
                passwordDetails.newPswd != '' &&
                hasUppercase &&
                hasLowercase &&
                hasNumber &&
                hasSplcharacter
              "
              src="../../assets/New Profile/match.svg"
              alt=""
            />

            <img
              class="match-hlepsec-searchicon"
              v-else-if="
                !passwordsMatch &&
                passwordDetails.confirmPswd != '' &&
                passwordDetails.newPswd != ''
              "
              src="../../assets/New Profile/no-match.svg"
              alt=""
            />
          </div>

          <div
            class="candash-errortxt errortxt-pos ml-1"
            v-if="
              $v.passwordDetails.confirmPswd.$dirty &&
              !$v.passwordDetails.confirmPswd.required
            "
          >
            Required
          </div>
          <div
            v-else-if="!$v.passwordDetails.confirmPswd.maxLength"
            class="candash-errortxt errortxt-pos ml-1"
          >
            Exceeded the max char length of 55
          </div>
          <div
            class="candash-errortxt errortxt-pos ml-1"
            v-else-if="
              !passwordsMatch &&
              passwordDetails.confirmPswd != '' &&
              passwordDetails.newPswd != ''
            "
          >
            Password doesn't match
          </div>
        </div>
      </div>
      <div class="mobile-footer pr-3">
        <div class="d-flex">
          <b-button
            class="acs-cancelBtn-modal"
            @click="
              cancelResetPswd(), (showPassword = true), (changePassword = false)
            "
            :disabled="pswLoader == true"
            >Cancel</b-button
          >
          <b-button
            :class="
              pswLoader
                ? 'acs-addBtn-modal loader-class ml-4 defaultCursor '
                : 'acs-addBtn-modal ml-4 pointer'
            "
            @click="resetPwd()"
            ><span v-if="!pswLoader">Save</span></b-button
          >
          <Loader v-if="pswLoader" class="profile-loader" />
        </div>
      </div>
    </div>
    <div v-if="showActivityShimmer">
      <div
        v-for="(i, index) in loopvar"
        :key="index"
        class="mb-white-card p-3 position-relative mb-3"
      >
        <div class="">
          <!-- <div class="mb-yellow-tag yellow-tag-pos">Currently Active</div> -->
          <div>
            <div class="d-flex align-items-center mb-mobile-txt-2 mt-1">
              <b-skeleton type="avatar"></b-skeleton>
              <b-skeleton class="ml-3 w-85"></b-skeleton>
            </div>
            <div class="mb-line-div mt-2"></div>
            <b-row class="mt-2">
              <b-col>
                <b-skeleton class="ml-3"></b-skeleton>
                <b-skeleton class="ml-3"></b-skeleton>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="6">
                <b-skeleton class="ml-3 w-85"></b-skeleton>
                <b-skeleton class="ml-3 w-85"></b-skeleton>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else-if="showAllDevices && !showActivityShimmer"
      class="mobile-body p-0"
    >
      <div class="h91 p-3 overflow-auto">
        <div
          v-if="Object.keys(currentlyTrue).length != 0"
          class="mb-white-card p-3 position-relative mb-3"
        >
          <div
            class="mb-yellow-tag yellow-tag-pos"
            v-if="currentlyTrue.current"
          >
            Currently Active
          </div>
          <div class="d-flex align-items-center mb-mobile-txt-2 mt-1">
            <img
              class="mr-2"
              src="../../assets/mobProfile/mb-chrome.svg"
              alt=""
            />

            {{ currentlyTrue.browser }}
          </div>
          <div class="mb-line-div mt-2"></div>
          <b-row class="mt-2">
            <b-col>
              <div class="mb-black-txt">Started at</div>
              <div class="mb-black-txt-3 mt-1">{{ currentlyTrue.started }}</div>
            </b-col>
            <b-col>
              <div class="mb-black-txt">Expires at</div>
              <div class="mb-black-txt-3 mt-1">{{ currentlyTrue.expires }}</div>
            </b-col>
          </b-row>
          <div class="mt-2 d-flex justify-content-between">
            <div>
              <div class="mb-black-txt">Last accessed on</div>
              <div class="mb-black-txt-3 mt-1">
                {{ currentlyTrue.lastAccess }}
              </div>
            </div>
            <div
              class="d-flex align-items-end mb-descriptn-txt-4 pointer"
              @click="signOutConfirm(currentlyTrue)"
            >
              Sign Out
            </div>
          </div>
        </div>
        <div v-for="(i, index) in device" :key="index">
          <div
            v-for="(j, index2) in i.sessions"
            :key="index2"
            :class="
              !j.current ? 'mb-white-card p-3 position-relative mb-3' : ''
            "
          >
            <!-- <div class="mb-yellow-tag yellow-tag-pos">Currently Active</div> -->
            <div v-if="!j.current && !showActivityShimmer">
              <div class="d-flex align-items-center mb-mobile-txt-2 mt-1">
                <img
                  class="mr-2"
                  src="../../assets/mobProfile/mb-chrome.svg"
                  alt=""
                />

                {{ j.browser }}
              </div>
              <div class="mb-line-div mt-2"></div>
              <b-row class="mt-2">
                <b-col>
                  <div class="mb-black-txt">Started at</div>
                  <div class="mb-black-txt-3 mt-1">{{ j.started }}</div>
                </b-col>
                <b-col>
                  <div class="mb-black-txt">Expires at</div>
                  <div class="mb-black-txt-3 mt-1">{{ j.expires }}</div>
                </b-col>
              </b-row>
              <div class="mt-2 d-flex justify-content-between">
                <div>
                  <div class="mb-black-txt">Last accessed on</div>
                  <div class="mb-black-txt-3 mt-1">{{ j.lastAccess }}</div>
                </div>
                <div
                  class="d-flex align-items-end mb-descriptn-txt-4"
                  @click="signOutConfirm(j)"
                >
                  Sign Out
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mobile-footer pr-3">
        <!-- <b-button class="mb-cancelBtn">Cancel</b-button> -->
        <b-button
          class="acs-addBtn-modal ml-3"
          @click="$bvModal.show('signOutModal')"
          >Sign out all devices</b-button
        >
        <!-- <b-button class="acs-addBtn-modal ml-3">Edit</b-button> -->
      </div>
    </div>
    <div v-if="showQuery" class="mobile-body">
      <div class="mobile-inner-body h99 p-3 position-relative">
        <div class="mob-query-img">
          <img class="" src="../../assets/mobProfile/mob-query.svg" alt="" />
          <b-button
            @click="
              (showQuery = false),
                (showConcern = true),
                (concern = ''),
                $v.concern.$reset()
            "
            class="acs-addBtn-modal mt-3 ml-5"
            >Raise Query</b-button
          >
        </div>
      </div>
    </div>
    <div v-if="showConcern" class="mobile-body">
      <div class="mobile-inner-body p-3">
        <div>
          <div class="mb-modal-label">
            Explain your concern<span class="asterik">*</span>
          </div>
          <div class="mt-1">
            <b-form-textarea
              :class="
                $v.concern.$error
                  ? 'mb-profile-inputField-error'
                  : 'mb-profile-inputField'
              "
              rows="5"
              max-rows="5"
              no-resize
              placeholder="Enter"
              v-model="$v.concern.$model"
              :maxlength="200"
            >
            </b-form-textarea>
            <div
              class="mt-1 validation-started-at ml-1"
              v-if="$v.concern.$dirty && !$v.concern.required"
            >
              Required
            </div>

            <div class="mt-1 started-at" v-else>
              {{ charactersLeft }} characters left
            </div>
          </div>
        </div>
      </div>

      <div class="mobile-footer pr-3">
        <div class="d-flex">
          <b-button
            class="acs-cancelBtn-modal"
            @click="(showConcern = false), (showQuery = true)"
            :disabled="queryLoader == true"
            >Cancel</b-button
          >
          <b-button
            :class="
              queryLoader
                ? 'acs-addBtn-modal loader-class ml-4 defaultCursor '
                : 'acs-addBtn-modal ml-4 pointer'
            "
            @click="raiseQueries()"
            ><span v-if="!queryLoader">Submit</span></b-button
          >
          <Loader v-if="queryLoader" class="profile-loader" />
        </div>
      </div>
    </div>
    <b-modal id="signedout" centered hide-footer hide-header @hidden="$bvModal.hide('signedout')">
      <div class="d-flex flex-column align-items-center p-2">
        <div>
          <img src="../../assets/New Profile/successBig.svg" alt="" />
        </div>
        <div class="teams-modal-head mt-3 text-center">
          You have been signed out of all<br />
          devices.
        </div>
        <div class="mt-1"></div>
        <div class="mt-4">
          <b-button class="acs-addBtn-modal" @click="$bvModal.hide('signedout')"
            >Okay</b-button
          >
        </div>
      </div>
    </b-modal>
    <b-modal id="signOutModal" size="md" centered hide-footer hide-header @hidden="closeSignout()">
      <div class="d-flex flex-column align-items-center p-2">
        <div>
          <img src="../../assets/New Profile/sign-out-icon.svg" alt="" />
        </div>
        <div class="mb-header-txt mt-3 text-center">
          Are you sure you want to log out of
          {{ selectedDevice == null ? "all devices" : "this device" }}?
        </div>
        <div class="d-flex align-items-center justify-content-end mt-4 bluebtn">
          <b-button
            :disabled="deviceLoader == true"
            class="acs-cancelBtn-modal pointer"
            @click="!deviceLoader ? closeSignout() : ''"
          >
            Cancel
          </b-button>

          <div class="relativeclass">
            <b-button
              class="acs-addBtn-modal ml-3"
              :class="
                deviceLoader ? 'loader-class-signout defaultCursor' : 'pointer'
              "
              @click="
                selectedDevice == null
                  ? ((deviceSignOut = true), signOutAllDevices())
                  : signOut(selectedDevice)
              "
            >
              <span v-if="!deviceLoader">Sign Out</span>
            </b-button>
            <div v-if="deviceLoader" class="loader-pos-signout">
              <Loader />
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="submitQuery"
      size="md"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      @hidden="$bvModal.hide('submitQuery'),
                (showConcern = false),
                (showQuery = true)"
    >
      <div class="d-flex flex-column align-items-center p-2">
        <div>
          <img src="../../assets/New Profile/submitted-icon.svg" alt="" />
        </div>
        <div class="mb-header-txt mt-3 text-center">
          <div class="teams-modal-head">Successfully Submitted!</div>
        </div>
        <div class="d-flex justify-content-between">
          <div class="mt-2 teams-delete-folder-font">
            Please Note Ticket No. for further reference.
          </div>
        </div>

        <div
          class="
            mt-2
            submitQuey-ticketNo
            d-flex
            align-items-center
            justify-content-between
            w-100
          "
        >
          <div>{{ ticketId }}</div>
          <div>
            <img
              v-if="!linkCopied"
              class="pointer"
              @click="copyTheLink(ticketId)"
              src="../../assets/New Profile/copyBtn.svg"
              alt=""
            />
            <img v-else src="../../assets/mobProfile/mob-copied.svg" alt="" />
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-end mt-4 bluebtn">
          <b-button
            class="acs-addBtn-modal pl-5 pr-5"
            @click="
              $bvModal.hide('submitQuery'),
                (showConcern = false),
                (showQuery = true)
            "
            >Close</b-button
          >
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import accountSettingsMixins from "../AccountSettings/accountSettingsMixins";

export default {
  name: "MobileProfile",
  mixins: [accountSettingsMixins],

  created() {
    this.showMainPage = true;
  },
  methods: {
    deviceActivity() {
      (this.showActivityShimmer = true),
        (this.showAllDevices = true),
        (this.showMainPage = false),
        (this.showDataShimmer = false);
      this.showQuery = false;
      this.showConcern = false;
      this.getDeviceActivity();
    },
    basicAuthentication() {
      (this.showPassword = true),
        (this.showMainPage = false),
        (this.showActivityShimmer = false),
        (this.showVisibilityShimmer = false),
        (this.showConcern = false);

      this.showDataShimmer = false;
      this.showQuery = false;

      this.cancelResetPswd();
    },
    personalData() {
      (this.showDataShimmer = true), (this.showConcern = false);

      (this.showMainPage = false),
        (this.showForm = true),
        (this.showActivityShimmer = false),
        (this.editProfile = false);
      this.showQuery = false;

      this.getprofileDetails();
    },
    raiseQuerytab() {
      this.showMainPage = false;
      this.showQuery = true;
      this.showConcern = false;
    },
  },
};
</script>

<style>
.h91 {
  height: 91%;
}
.loader-pos-signout {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: 16px;
}
.loader-class-signout {
  opacity: 0.5;
  height: 28px;
  width: 89px;
}
.profile-loader {
  width: fit-content !important;
  height: -moz-fit-content !important;
  height: fit-content !important;
  margin: 0px auto !important;
  position: relative !important;
  top: -24px !important;
  right: 87px !important;
}
.mobile-header {
  position: relative;
  z-index: 2066;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: none !important;
  background-color: #ffffff;
  height: 9%;
}

.mobile-body {
  height: 91%;
  background-color: #e9ecef;
  padding: 20px 15px;
  overflow: auto;
}

.mobile-body-scroll {
  height: 91%;
  background-color: #e9ecef;
  padding: 10px 15px;
  overflow: hidden;
}

.mb-descriptn-txt-4 {
  font-family: "Montserrat", sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #20639b;
}

.mobile-body-2 {
  height: 91%;
  background-color: #ffffff;
  overflow: auto;
}

.mobile-inner-body {
  height: 91%;
  background-color: #ffffff;
  overflow: auto;
  border-radius: 4px 4px 0px 0px;
}

.mb-modal-label {
  color: #344054;
  font-family: "Montserrat", sans-serif;
  font-size: var(--size-12) !important;
  font-weight: var(--weight-M);
}
.mobile-footer {
  width: 100%;
  height: 9%;
  background-color: #ffffff;
  border-top: 1px solid #8c8c8c40;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-radius: 0px 0px 4px 4px;
}

.mobile-footer-2 {
  width: 100%;
  height: 9%;
  background-color: #ffffff;
  /* border-top: 1px solid #8c8c8c40; */
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-radius: 0px 0px 4px 4px;
}

.mb-dashboard-card {
  background-color: #ffffff;
  word-break: break-all;
  border-radius: 6px;
}

.mb-background-img {
  position: absolute;
  top: 0px;
  left: 0px;
}

.mb-dashboard-card-skill {
  background-color: #ffffff;
  word-break: break-all;
  border-radius: 6px;
  height: 100%;
  overflow: auto;
}

.mb-profile-pic-pos {
  position: absolute;
  right: 20px;
  top: 15px;
}

.mb-profile-pic {
  border-radius: 50%;
  height: 80px;
  width: 80px;
  z-index: 4;
  border: 2px solid #ffffff;
}

.avatar-profile-pic {
  border-radius: 50%;
  height: 80px;
  width: 80px;
  z-index: 4;
}

.mb-sl-pos {
  position: absolute;
  right: -4px;
  bottom: -11px;
}

.mb-blueback {
  background-color: #20639b;
  border-radius: 6px 6px 0px 0px;
  padding: 12px 0px 11px 13px;
  box-shadow: 0px 4px 8px 0px #0000002b;
  position: relative;
}

.mb-white-bold-txt {
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
}

.mb-small-white-txt {
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
}

.mb-small-white-txt-2 {
  font-family: "Lato", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
}

.mb-mail-txt {
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: #20639b;
  text-decoration: underline;
}

.mb-mail-txt-2 {
  font-family: "Montserrat", sans-serif;
  font-size: 10px;
  font-weight: 500;
  color: #20639b;
  text-decoration: underline;
}

.mb-mobile-txt {
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #3a3c40;
}

.mb-mobile-txt-2 {
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #3a3c40;
}

.mb-black-bold {
  font-family: "Lato", sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #000000;
}

.mb-black-bold-2 {
  font-family: "Lato", sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #000000;
}
.mobile-header {
  position: relative;
  z-index: 2066;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px -12px 26px 0px #000000;
  background-color: #ffffff;
  height: 9%;
}
.mb-header-txt {
  font-family: "Lato", sans-serif;
  font-size: 18px;
  font-weight: 500;
  color: #000000;
}
.mb-profile-inputField {
  border-radius: 10px;
  border: 1px solid var(--gray-300, #d0d5dd);
  background: var(--base-white, #fff);
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  color: #333;
  font-size: 14px;
  font-weight: 500;
  /* padding: 18px 10px; */
  /* height: 32px; */
}

.mb-profile-inputField-error {
  border-radius: 10px;
  border: 1px solid #eb0002;
  background: var(--base-white, #fff);
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  color: #333;
  font-size: 14px;
  font-weight: 500;
  /* padding: 18px 10px; */
  /* height: 32px; */
}

.mb-profile-inputField:focus {
  box-shadow: none;
}

.mb-profile-inputField-error:focus {
  box-shadow: none;
  border: 1px solid #eb0002;
}

.mb-profile-inputField:disabled {
  background: #ebebeb;
  opacity: 0.65;
  border: unset;
}
.no-resume-text {
  color: #333333;
  font-size: 16px;
  font-weight: 600;
}
.candash-errortxt {
  color: #eb0002;
  font-size: var(--size-10);
  font-weight: var(--weight-R);
}
.errortxt-pos {
  position: absolute;
}
.cd-hlepsec-searchicon {
  position: absolute;
  right: 10px;
  top: 9px;
}

.mbPro-hlepsec-searchicon {
  position: absolute;
  right: 35px;
  top: 13px;
}

.match-hlepsec-searchicon {
  position: absolute;
  right: 10px;
  top: 35px;
}
.mb-white-card {
  background-color: #ffffff;
  border-radius: 4px;
}
.mb-white-body {
  background-color: #ffffff;
  height: 100%;
  border-radius: 5px;
  padding: 18px;
}
.mb-red-font {
  color: #eb0002;
  font-size: 10px;
  font-weight: 500;
  font-family: "Montserrat", sans-serif;
}

.mb-green-font {
  color: #0f6b00;
  font-size: 10px;
  font-weight: 500;
  font-family: "Montserrat", sans-serif;
}
.mb-yellow-tag {
  background-color: #ffb200;
  border-radius: 8px 20px 20px 0px;
  padding: 1px 7px 1px 5px;
  font-size: 8px;
  font-weight: 500;
  font-family: "Montserrat", sans-serif;
  color: #ffffff;
  width: fit-content;
}
.mb-black-txt {
  font-family: "Montserrat", sans-serif;
  font-size: 10px;
  font-weight: 500;
  color: #3a3c40;
}

.mb-black-txt-2 {
  font-family: "Montserrat", sans-serif;
  font-size: 10px;
  font-weight: 500;
  color: #333333;
}

.mb-black-txt-3 {
  font-family: "Montserrat", sans-serif;
  font-size: 10px;
  font-weight: 600;
  color: #3a3c40;
}
.loader-class {
  opacity: 0.5;
  height: 32px;
  width: 87px;
}
.h99 {
  height: 99%;
}
.mob-query-img {
  position: absolute;
  top: 36%;
  left: 17%;
}
.started-at {
  color: #7a7a7a;
  font-size: 13px;
  font-weight: 500;
  font-family: "Montserrat";
}
.validation-started-at {
  color: #eb0002;
  font-size: 10px;
  font-weight: 500;
}

.submitQuey-ticketNo {
  background: #e8eff4;
  padding: 4px 7px;
  font-family: "Montserrat", "sans-serif";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #20639b;
}
</style>
